import { ref } from 'vue';
import PricingCatalogAPI from '@/api/pricingCatalog';

export function usePricingCatalog() {
  const selectedFile = ref(null);
  const loading = ref(false);
  const message = ref('');
  const messageType = ref('success');

  const downloadCatalog = async () => {
    loading.value = true;
    message.value = '';

    try {
      const response = await PricingCatalogAPI.download();

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'pricing_catalog.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();

      showMessage('Catalog downloaded successfully', 'success');
      return true;
    } catch (error) {
      showMessage('Failed to download catalog: ' + (error.response?.data?.error || error.message), 'error');
      return false;
    } finally {
      loading.value = false;
    }
  };

  const uploadCatalog = async (file) => {
    if (!file) return false;

    loading.value = true;
    message.value = '';

    try {
      await PricingCatalogAPI.upload(file);

      selectedFile.value = null;
      showMessage('Custom pricing catalog uploaded successfully!', 'success');
      return true;
    } catch (error) {
      showMessage('Failed to upload catalog: ' + (error.response?.data?.error || error.message), 'error');
      return false;
    } finally {
      loading.value = false;
    }
  };

  const resetToDefault = async () => {
    loading.value = true;
    message.value = '';

    try {
      await PricingCatalogAPI.reset();

      selectedFile.value = null;
      showMessage('Reset to default catalog successfully', 'success');
      return true;
    } catch (error) {
      showMessage('Failed to reset catalog: ' + (error.response?.data?.error || error.message), 'error');
      return false;
    } finally {
      loading.value = false;
    }
  };

  const showMessage = (text, type = 'success') => {
    message.value = text;
    messageType.value = type;
    setTimeout(() => {
      message.value = '';
    }, 5000);
  };

  return {
    selectedFile,
    loading,
    message,
    messageType,
    downloadCatalog,
    uploadCatalog,
    resetToDefault
  };
}
